const patternNumber = /^\d{1,10}$/;
const patternPurse = /^\d{12,15}$/;

export default {
  data() {
    return {
      current: {},
      config: {},
      operators: [],
      banks: [],
      settings: [],
      paymentFinish: false,
      isLoad: false,
      form: {
        value: '',
        amount: '',
        valid: true,
        purse_id: '',
        additional_agreement: false,
        operator: null,
        bank: null,
        card_date_issue: '',
        card_cvv: '',
        card_cardholder: '',
        card_phone_number: '',
      },
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        phoneLength: value => (value && value.length >= 17)
          || 'Номер телефона заполнен не полностью',
        cardLength: value => (value && value.length >= 19) || 'Номер карты заполнен не полностью',
        summLength: value => (value && +value >= 1500) || 'Сумма должна быть больше 1500р',
        number: value => patternNumber.test(value) || 'Поле должно содержать только числа',
        purse: value => patternPurse.test(value) || 'Поле должно содержать только числа',
        purse_id: value => patternPurse.test(value) || 'Поле должно содержать только числа',
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    hasPurses() {
      return this.$store.state.purses.length !== 0;
    },
    purses() {
      const { purses } = this.$store.state;
      this.form.purse_id = purses[0]?.id || '';
      return purses;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    paymentsInfo() {
      const { paymentsInfo } = this.$store.state;
      return paymentsInfo;
    },
    paymentsConfig() {
      return this.$store.state.paymentsConfig;
    },
    paymentOperators() {
      return this.$store.state.paymentOperators;
    },
    paymentBanks() {
      return this.$store.state.paymentBanks;
    },
    hasTaxes() {
      return this.$store.state.settings.taxes === true;
    },
    userHasPassport() {
      return (
        this.user
        && this.user.account
        && this.user.account.status === 'approved'
      );
    },
  },
  methods: {
    handleChangeMethod(item) {
      this.current = item;
      this.ResetForm();
    },
    paymentSubmit() {
      const app = this;
      if (app.form.valid) {
        app.isLoad = true;
        const payment = {
          profile_id: app.user.profile_id,
          type: app.current.type,
          amount: app.form.amount,
          purse_id: app.form.purse_id || this.purses[0]?.id || '',
          additional_agreement: app.form.additional_agreement,
          parameters: {
            phone_mobile: app.form.value,
            operator: app.form.operator,
            bank: app.form.bank,
            card_date_issue: app.form.card_date_issue,
            card_cvv: app.form.card_cvv,
            card_cardholder: app.form.card_cardholder,
            card_phone_number: app.form.card_phone_number,
          },
        };
        app.$store.getters.axl
          .post('payments/api-v5/payments/create', payment)
          .then(() => {
            app.ResetForm();
            this.$store.dispatch('GetProfile');
            app.paymentFinish = true;
            this.$router.push({ name: 'orders', params: { type: 'payments' } });
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          })
          .finally(() => {
            app.isLoad = false;
          });
      }
    },
    ResetForm() {
      this.$refs.form.reset();
      this.form.amount = '';
      this.form.value = '';
    },
    CheckCardholder() {
      this.form.card_cardholder = this.form.card_cardholder
        .toUpperCase()
        .replace(/[^A-Z\s]+/gi, '');
    },
  },
  async mounted() {
    await this.$store.dispatch('GetPaymentsSettings');
    this.config = this.paymentsConfig;
    this.operators = this.paymentOperators;
    this.banks = this.paymentBanks;
    this.current = this.paymentsInfo?.length ? this.paymentsInfo[0] : {};
  },
};
